import React from 'react';

// CSS 클래스·keyframes 의존 없는 SMIL 회전 스피너 — WebView에서 Tailwind 애니메이션이 적용되지 않는 케이스 회피.
// 색상은 currentColor를 따르므로 부모의 text-* 클래스로 지정한다.
const Spinner: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-label="loading" role="img" className={className}>
    <g>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" fill="none" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" fill="none" />
      <animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
    </g>
  </svg>
);

export default Spinner;
